(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-technical-sheet"] && !Shopify.designMode) return;
  try {
    if (!window.productTechnicalSheetDownloadInitialized) {
    window.productTechnicalSheetDownloadInitialized = true;

    document.addEventListener('click', async (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const link = target.closest('[data-product-technical-sheet-download]');
      if (!link) return;

      event.preventDefault();

      if (link.dataset.downloadPending === 'true') return;

      const downloadUrl = link.getAttribute('href');
      const filename = link.getAttribute('download') || 'ficha-tecnica.pdf';

      if (!downloadUrl) return;

      link.dataset.downloadPending = 'true';
      link.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(downloadUrl, { redirect: 'follow' });

        if (!response.ok) {
          throw new Error(`Download failed with status ${response.status}`);
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');

        downloadLink.href = blobUrl;
        downloadLink.download = filename;
        downloadLink.style.display = 'none';

        document.body.append(downloadLink);
        downloadLink.click();
        downloadLink.remove();

        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      } catch (error) {
        console.warn('Unable to force the technical sheet download.', error);
      } finally {
        delete link.dataset.downloadPending;
        link.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
